import { render } from "./HsPagination.vue?vue&type=template&id=14272963"
import script from "./HsPagination.vue?vue&type=script&lang=js"
export * from "./HsPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__